import $ from 'jquery';

$(document).on('change', '.form-check-input', e => {
  const article_id = e.target.dataset.target;
  const checked = $(`#already_read_checkbox${article_id}`).prop('checked');
  const headers = {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  };

  if (checked) {
    $.ajax({
      url: '/already_reads',
      type: 'POST',
      headers,
      data: {
        already_read: { article_id: article_id },
      }
    });
  } else {
    $.ajax({
      url: `/already_reads/${article_id}`,
      type: 'DELETE',
      headers,
    });
  }
})

$(document).on('click', '.read_all', e => {
  e.preventDefault();

  if (confirm('全て既読にしてもよろしいですか？')) {
    const board_id = e.target.dataset.target;

    $(`#read_all_form_${board_id}`).submit();
  } else {
    return;
  }
})

$(document).on('submit', '#commentForm', e => {
  const value = $('#comment_content').val();
  if (!value) {
    e.preventDefault();
    if ($('#commentForm').find('.alert').length) {
      $('.alert').remove();
    }

    const message = $('<div>', {
      text: 'コメントを入力してください',
      class: 'alert alert-danger'
    });
    $('#commentForm').prepend(message);
    $('#commentButton').blur();
  }
})

$(document).on('click', '.cancel', () => {
  $('.modal').removeClass('open');
  $('#mce-modal-block').remove();
})

$(document).on('click', '.year_top', e => {
  const year = e.target.dataset.target;

  $(`.archives_${year}`).toggle('fast');
})

$(document).on('change', '[name=search_type]', e => {
  const form = $('#home_search_form');
  const searchType = e.target.value;

  if (searchType === 'neuron') {
    form.attr('target', '_blank');
  } else {
    form.removeAttr('target');
  }
})

